import React from "react";
import { Card, Typography, Row, Col } from "antd";
import "./CookiePolicy.module.css";

const { Title, Paragraph } = Typography;

const CookiePolicyPage: React.FC = () => {
  return (
    <div className="cookie-policy-page">
      <Row gutter={[16, 16]} justify="center">
        <Col xs={24} md={20} lg={16}>
          <Card>
            <Title level={1}>Cookie Policy</Title>

            <Paragraph>
              Il sito corerare.it utilizza esclusivamente cookie di sessione
              necessari per la gestione della login e per garantire la sicurezza
              dell'accesso alla piattaforma.
            </Paragraph>

            <Title level={2}>Cosa sono i cookie:</Title>
            <Paragraph>
              I cookie sono piccoli file di testo memorizzati sul dispositivo
              dell'utente per migliorare la navigazione e le funzionalità del
              sito.
            </Paragraph>

            <Title level={2}>Tipologie di cookie utilizzati:</Title>
            <Paragraph>
              - Cookie tecnici: necessari per il funzionamento del sito (es.
              login, sessione)
            </Paragraph>

            <Title level={2}>Gestione dei cookie:</Title>
            <Paragraph>
              Poiché il sito utilizza solo cookie tecnici, non è richiesto il
              consenso esplicito dell'utente. Tuttavia, l'utente può modificare
              le preferenze dei cookie tramite le impostazioni del browser.
              L'interruzione dei cookie può limitare alcune funzionalità del
              sito.
            </Paragraph>

            <Title level={2}>Consenso:</Title>
            <Paragraph>
              Continuando la navigazione, l'utente acconsente all'uso dei cookie
              secondo le modalità indicate in questa informativa.
            </Paragraph>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default CookiePolicyPage;
